<template>
  <div id="page-login" class="login-main">
    <div class="login-container">

      <div class="login-top">
        <img src="../../../public/img/TurkishRestaurantLogo.png" />
      </div>
      <div class="login-mid fp">
        <h3>Reset Password</h3>
        <input
          type="password"
          name="password"
          placeholder="New Password"
          v-model="password"
          class="login-input" />
        <input
            type="password"
            name="repassword"
            placeholder="Confirm New Password"
            v-model="repassword"
            class="login-input" />
    </div>
    <div class="login-bottom">
      <button class="login-button" @click="login">Change Password</button>
      <a href="/login" class="login-back-button"><i class="fas fa-user"></i> Sign in</a>
    </div>
    </div>
  </div>
</template>

<script>

export default{
  props: {
    token: {
      type: String
    }
  },
  data () {
    return {
      password: '',
      repassword: ''
    }
  },
  methods: {
    login () {
      if (this.token) {
        if (this.password !== '') {
          if (this.password === this.repassword) {
            this.$vs.loading()
            const passmail = {
              resetToken: this.token, //'serkan.erdinc@asay.com.tr',
              password: this.password,
              rePassword: this.repassword,
              user_group: 4
            }
            this.$store.dispatch('api/resetPassword', passmail)
              .then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Password reset successful',
                  text: 'Redirecting to home',
                  iconPack: 'feather',
                  icon: 'icon-check',
                  color: 'success'
                })
                this.$router.push('/login')
              })
              .catch(error => {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Error',
                  text: error.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
              })
          } else {

            this.$vs.notify({
              title: 'Error',
              text: 'Passwords do not match',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }

        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Password field can not be empty',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        }
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Password token can not be found',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }

    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
  .login-header {
    text-align: center;
    padding: 1rem;
    justify-content: center;
  }
  .vx-card {
    overflow:hidden;
  }
  .vx-logo-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
